var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useMemo, useState } from 'react';
import { translate } from '@utils/i18n';
import Brushaway from '../../../../components/Brushaway';
import TextInput from '@components/TextInput/TextInput';
import { SelectInput } from '@ui/molecules/inputs/form/SelectInput/SelectInput';
import { namespace } from './constants';
import '../../FormLibrary/styles.scss';
function BackFlowTypeDetail({ backFlowType, onClose, onSubmit, territories, frequencies }) {
    const [editBackFlowType, setEditBackFlowType] = useState(backFlowType);
    useEffect(() => {
        if (backFlowType) {
            setEditBackFlowType(Object.assign(Object.assign({}, backFlowType), { frequencyIds: backFlowType.hasAllFrequencies ? frequencies.map((f) => f.value) : backFlowType.frequencyIds }));
        }
    }, [backFlowType]);
    const allSelected = useMemo(() => {
        return (editBackFlowType === null || editBackFlowType === void 0 ? void 0 : editBackFlowType.frequencyIds.length) === frequencies.length;
    }, [frequencies, editBackFlowType === null || editBackFlowType === void 0 ? void 0 : editBackFlowType.frequencyIds]);
    const handleSubmitForm = () => __awaiter(this, void 0, void 0, function* () {
        if (editBackFlowType) {
            return onSubmit(Object.assign(Object.assign({}, editBackFlowType), { hasAllFrequencies: allSelected, frequencyIds: allSelected ? [] : editBackFlowType.frequencyIds }));
        }
        return false;
    });
    const handleNameChange = (event) => {
        if (editBackFlowType) {
            setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { displayName: event.target.value }));
        }
    };
    const handleActiveChange = (event) => {
        if (editBackFlowType) {
            setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { active: event.target.checked }));
        }
    };
    const handleTerritoryChange = (values) => {
        if (editBackFlowType) {
            setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { territoryIds: values }));
        }
    };
    const onChangeFrequency = (frequency) => {
        if (editBackFlowType) {
            if (editBackFlowType.frequencyIds.includes(frequency.value)) {
                setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { frequencyIds: editBackFlowType.frequencyIds.filter((id) => id !== frequency.value) }));
            }
            else {
                setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { frequencyIds: [...editBackFlowType.frequencyIds, frequency.value] }));
            }
        }
    };
    const onSelectAllClicked = () => {
        if (editBackFlowType) {
            if (allSelected) {
                setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { frequencyIds: [] }));
            }
            else {
                setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { frequencyIds: frequencies.map((f) => f.value) }));
            }
        }
    };
    return (React.createElement(Brushaway, { open: backFlowType !== null, title: translate('edit_title', { namespace }), isForm: true, onClose: () => {
            onClose();
        }, onSubmit: handleSubmitForm },
        React.createElement("div", { className: "form-edit-container" },
            React.createElement("div", { className: "form-section" },
                React.createElement(TextInput, { id: "name", value: editBackFlowType === null || editBackFlowType === void 0 ? void 0 : editBackFlowType.displayName, label: translate('name_label', { namespace }), onChange: handleNameChange }),
                territories.length > 0 && (React.createElement("div", { className: "mt-3" },
                    React.createElement(SelectInput, { label: translate('territories_label', { namespace }), options: territories, values: (editBackFlowType === null || editBackFlowType === void 0 ? void 0 : editBackFlowType.territoryIds) || [], onMultiChange: handleTerritoryChange, multiple: true, showSearch: true, displayMode: "labels", className: "mb-1" }),
                    React.createElement("small", { className: "note-section" },
                        React.createElement("i", { className: "fa fa-light fa-circle-info mr-1" }),
                        translate('territories_hint', { namespace })))),
                React.createElement("label", { className: "qmb-checkbox mt-3" },
                    React.createElement("input", { type: "checkbox", checked: editBackFlowType === null || editBackFlowType === void 0 ? void 0 : editBackFlowType.active, onChange: handleActiveChange }),
                    React.createElement("p", { className: "qmb-checkbox-label", style: { padding: 0 } },
                        React.createElement("span", { className: "qmb-checkbox-title" }, 'Active'))),
                React.createElement("div", { className: "mt-3" },
                    translate('select_intervals', { namespace }),
                    ":"),
                React.createElement("div", { className: "qmb-checkbox" },
                    React.createElement("input", { className: "qmb-checkbox__input", type: "checkbox", id: "frequency-select-all", checked: allSelected, onChange: () => onSelectAllClicked() }),
                    React.createElement("label", { htmlFor: "frequency-select-all" }, translate('select_all', { namespace }))),
                frequencies.map((frequency) => (React.createElement("div", { key: frequency.value, className: "qmb-checkbox" },
                    React.createElement("input", { className: "qmb-checkbox__input", type: "checkbox", id: `frequency-${frequency.value}`, checked: (editBackFlowType === null || editBackFlowType === void 0 ? void 0 : editBackFlowType.frequencyIds.includes(frequency.value)) || false, onChange: () => onChangeFrequency(frequency) }),
                    React.createElement("label", { htmlFor: `frequency-${frequency.value}` }, frequency.label))))),
            React.createElement("div", { className: "note-section" }, translate('edit_detail_note', { namespace, inspections: backFlowType === null || backFlowType === void 0 ? void 0 : backFlowType.inspectionsCount })))));
}
export default BackFlowTypeDetail;
